var app = angular.module('leonardo');

var RemoveActionDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      removeColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.removeColor ? ConfigThemeService.getColor(scope.removeColor) : ConfigThemeService.getColor('tertiaryColor', 0.2);
        element.css('background-color', color);
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('removeAction', ['ConfigThemeService', RemoveActionDirective]);
